// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ExperienceYears-module__wrapper___4QDKS {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding-top: 32px;\n}\n\n.ExperienceYears-module__selectionWrapper___9Wbd0 {\n  display: flex;\n  flex-direction: row;\n  max-width: 400px;\n  grid-gap: 16px;\n  grid-gap: 16px;\n  gap: 16px;\n  justify-content: center;\n  padding: 16px 16px 16px 16px;\n  flex-wrap: wrap;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "ExperienceYears-module__wrapper___4QDKS",
	"selectionWrapper": "ExperienceYears-module__selectionWrapper___9Wbd0"
};
export default ___CSS_LOADER_EXPORT___;
